declare namespace $ {

	type __shm_dashboard_app_1 = $mol_type_enforce<
		Parameters< $shm_dashboard_app['dashboard_id'] >[0]
		,
		Parameters< ReturnType< $shm_dashboard_app['Dashboard_list'] >['dashboard_id'] >[0]
	>
	type $shm_dashboard_opencode_app__dashboard_shm_dashboard_app_2 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['dashboard_model'] >
		,
		ReturnType< $shm_dashboard_opencode_app['dashboard'] >
	>
	type $shm_dashboard_opencode_app__dashboard_id_shm_dashboard_app_3 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['dashboard_id'] >
		,
		ReturnType< $shm_dashboard_opencode_app['dashboard_id'] >
	>
	type $shm_dashboard_opencode_app__dashboard_title_shm_dashboard_app_4 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['dashboard_title_current'] >
		,
		ReturnType< $shm_dashboard_opencode_app['dashboard_title'] >
	>
	type $mol_list__rows_shm_dashboard_app_5 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['settings_rows'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $shm_dashboard_app_menu__agent_enabled_shm_dashboard_app_6 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['agent_tab_enabled'] >
		,
		ReturnType< $shm_dashboard_app_menu['agent_enabled'] >
	>
	type $shm_dashboard_app_menu__monitoring_only_shm_dashboard_app_7 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['monitoring_only'] >
		,
		ReturnType< $shm_dashboard_app_menu['monitoring_only'] >
	>
	type $shm_dashboard_app_menu__dashboard_list_shm_dashboard_app_8 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['Dashboard_list'] >
		,
		ReturnType< $shm_dashboard_app_menu['dashboard_list'] >
	>
	type $shm_dashboard_app_menu__app_section_shm_dashboard_app_9 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['app_section'] >
		,
		ReturnType< $shm_dashboard_app_menu['app_section'] >
	>
	type $shm_dashboard_app_menu__agent_opened_shm_dashboard_app_10 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['agent_opened'] >
		,
		ReturnType< $shm_dashboard_app_menu['agent_opened'] >
	>
	type $shm_dashboard_app_menu__wordstat_enabled_shm_dashboard_app_11 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['wordstat_enabled'] >
		,
		ReturnType< $shm_dashboard_app_menu['wordstat_enabled'] >
	>
	type $shm_dashboard_app_menu__mentions_enabled_shm_dashboard_app_12 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['mentions_enabled'] >
		,
		ReturnType< $shm_dashboard_app_menu['mentions_enabled'] >
	>
	type $shm_dashboard_app_menu__mention_stats_enabled_shm_dashboard_app_13 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['mention_stats_enabled'] >
		,
		ReturnType< $shm_dashboard_app_menu['mention_stats_enabled'] >
	>
	type $shm_wordstat_task_list__task_id_shm_dashboard_app_14 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['wordstat_task_id'] >
		,
		ReturnType< $shm_wordstat_task_list['task_id'] >
	>
	type $shm_wordstat_task_list__focus_queries_shm_dashboard_app_15 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['wordstat_queries_focus'] >
		,
		ReturnType< $shm_wordstat_task_list['focus_queries'] >
	>
	type $shm_wordstat_task_catalog__task_id_shm_dashboard_app_16 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['wordstat_task_id'] >
		,
		ReturnType< $shm_wordstat_task_catalog['task_id'] >
	>
	type $mol_view__sub_shm_dashboard_app_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_dashboard_mentions__app_id_shm_dashboard_app_18 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['dashboard_id'] >
		,
		ReturnType< $shm_dashboard_mentions['app_id'] >
	>
	type $shm_dashboard_mentions__dashboard_model_shm_dashboard_app_19 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['dashboard_model'] >
		,
		ReturnType< $shm_dashboard_mentions['dashboard_model'] >
	>
	type $shm_dashboard_mentions__agent_enabled_shm_dashboard_app_20 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['agent_enabled'] >
		,
		ReturnType< $shm_dashboard_mentions['agent_enabled'] >
	>
	type $shm_wordstat_dashboard__dashboard_id_shm_dashboard_app_21 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['wordstat_task_id'] >
		,
		ReturnType< $shm_wordstat_dashboard['dashboard_id'] >
	>
	type $shm_wordstat_dashboard__task_title_shm_dashboard_app_22 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['wordstat_task_title'] >
		,
		ReturnType< $shm_wordstat_dashboard['task_title'] >
	>
	type $shm_ba_mention_stats_task_list__task_id_shm_dashboard_app_23 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['mention_stats_task_id'] >
		,
		ReturnType< $shm_ba_mention_stats_task_list['task_id'] >
	>
	type $shm_ba_mention_stats_task__task_id_shm_dashboard_app_24 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['mention_stats_task_id'] >
		,
		ReturnType< $shm_ba_mention_stats_task['task_id'] >
	>
	type $mol_page__title_shm_dashboard_app_25 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_dashboard_app_26 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_ba_search_settings__search_mode_shm_dashboard_app_27 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['search_mode'] >
		,
		ReturnType< $shm_ba_search_settings['search_mode'] >
	>
	type $shm_ba_search_settings__search_case_sensitive_shm_dashboard_app_28 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['search_case_sensitive'] >
		,
		ReturnType< $shm_ba_search_settings['search_case_sensitive'] >
	>
	type $shm_echarts_settings__animation_duration_initial_shm_dashboard_app_29 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['chart_animation_initial'] >
		,
		ReturnType< $shm_echarts_settings['animation_duration_initial'] >
	>
	type $shm_echarts_settings__animation_duration_update_shm_dashboard_app_30 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['chart_animation_update'] >
		,
		ReturnType< $shm_echarts_settings['animation_duration_update'] >
	>
	type $shm_echarts_settings__animation_easing_shm_dashboard_app_31 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['chart_animation_easing'] >
		,
		ReturnType< $shm_echarts_settings['animation_easing'] >
	>
	type $shm_echarts_settings__animation_duration_initial_save_shm_dashboard_app_32 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['chart_animation_initial_save'] >
		,
		ReturnType< $shm_echarts_settings['animation_duration_initial_save'] >
	>
	type $shm_echarts_settings__animation_duration_update_save_shm_dashboard_app_33 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['chart_animation_update_save'] >
		,
		ReturnType< $shm_echarts_settings['animation_duration_update_save'] >
	>
	type $shm_hitalama_textbook__text_shm_dashboard_app_34 = $mol_type_enforce<
		ReturnType< $shm_dashboard_app['docs_text'] >
		,
		ReturnType< $shm_hitalama_textbook['text'] >
	>
	export class $shm_dashboard_app extends $mol_book2 {
		Theme( ): $mol_theme_auto
		telemetry_auto( ): any
		auth_route_auto( ): any
		navigation_log_auto( ): any
		chart_settings_sync( ): any
		app_pages( ): readonly(any)[]
		app_section( ): string
		agent_opened( next?: boolean ): boolean
		dashboard_id( next?: ReturnType< ReturnType< $shm_dashboard_app['Dashboard_list'] >['dashboard_id'] > ): ReturnType< ReturnType< $shm_dashboard_app['Dashboard_list'] >['dashboard_id'] >
		dashboard_model( ): ReturnType< ReturnType< $shm_dashboard_app['Dashboard_list'] >['dashboard_model'] >
		wordstat_task_id( next?: string ): string
		wordstat_queries_focus( next?: any ): any
		Agent_page( ): $shm_dashboard_opencode_app
		wordstat_task_title( next?: string ): string
		mention_stats_task_id( next?: string ): string
		settings_rows( ): readonly(any)[]
		Settings_screen( ): $mol_list
		search_mode( next?: string ): string
		search_case_sensitive( next?: boolean ): boolean
		chart_animation_initial( next?: number ): number
		chart_animation_update( next?: number ): number
		chart_animation_easing( next?: string ): string
		chart_animation_initial_save( next?: any ): any
		chart_animation_update_save( next?: any ): any
		docs_text( ): string
		plugins( ): readonly(any)[]
		agent_enabled( next?: boolean ): boolean
		agent_tab_enabled( ): boolean
		monitoring_only( ): boolean
		wordstat_enabled( ): boolean
		mentions_enabled( ): boolean
		mention_stats_enabled( ): boolean
		agent_min_version( ): string
		dashboard_title_current( ): string
		placeholders( ): readonly(any)[]
		auto( ): readonly(any)[]
		pages( ): ReturnType< $shm_dashboard_app['app_pages'] >
		Menu_page( ): $shm_dashboard_app_menu
		Dashboard_list( ): $shm_dashboard_app_dashboard_list
		Wordstat_tasks( ): $shm_wordstat_task_list
		Wordstat_catalog( ): $shm_wordstat_task_catalog
		Agent_panel( ): $mol_view
		Dashboard( ): $shm_dashboard_mentions
		Wordstat_dashboard( ): $shm_wordstat_dashboard
		Mention_stats_tasks( ): $shm_ba_mention_stats_task_list
		Mention_stats_task( ): $shm_ba_mention_stats_task
		Agent_app( ): $shm_dashboard_opencode_app
		Settings_page( ): $mol_page
		Search_settings( ): $shm_ba_search_settings
		User_settings( ): $shm_ba_user_settings
		Chart_settings( ): $shm_echarts_settings
		File_store_list( ): $shm_ba_file_store_list
		Documentation( ): $shm_hitalama_textbook
	}
	
}

//# sourceMappingURL=app.web.view.tree.d.ts.map